/* Two8 cart-drawer upsells (v7). Reads live cart state from the drawer DOM,
   shows Upsell A (single Movement/Super band) or Upsell B (single Pilates box),
   never both, never on carts of 2+ units. 28% comes from the automatic
   "The Two8 Deal - 28% Off Your Add-On" discount.
   v7 adds the Pilates box/bundle upgrade path and runs under its own init guard so
   it supersedes the legacy store-wide build, which the loader section neutralizes.
   v8.2 edit: on the Pilates path the "Upgrade to the Two8 Bands system" swap is
   suppressed while Pilates in a Box sits at $44 against the $50 system, and the
   remaining add-a-second-set button carries the final-run line. See markup().
   v8.2.1 edit: adds the Two8 Bands system box path (state key 'c'). The box was the
   only product path that fired no drawer offer. Additive only. The Movement, Super
   and Pilates paths above are unchanged.
   v8.2.2 edit, final edit pass: state 'c' copy only. The drawer is now the ONLY
   place the second-set offer appears anywhere on the store, because the pre-cart
   line in snippets/buy-buttons.liquid was removed. Since this is the one allowed
   place, the button no longer sells the discount: the copy is about who trains
   beside you, and the cart total does the revealing. The automatic discount named
   above applies itself in the cart, so nothing here applies, duplicates or stacks
   a discount. No logic, no state, no suppression rule and no other path changed. */
(function () {
  if (window.__two8CartUpsellInitV7) return;
  window.__two8CartUpsellInitV7 = true;
  window.__two8CartUpsellInit = true;

  (function injectCss(){
    if (document.getElementById('t8-upsell-css')) return;
    var st = document.createElement('style');
    st.id = 't8-upsell-css';
    st.textContent = '.t8-upsell-wrap{margin:0 0 1.2rem;}.t8-upsell{padding:1.4rem;border:0.1rem solid rgba(var(--color-foreground,18 18 18),0.12);border-radius:0.8rem;background:rgba(var(--color-foreground,18 18 18),0.03);}.t8-upsell__heading{margin:0 0 1.1rem;font-size:1.5rem;line-height:1.3;font-weight:600;letter-spacing:0.01rem;}.t8-upsell__btn{display:flex;flex-direction:column;gap:0.35rem;width:100%;text-align:center;padding:1.1rem 1.2rem;margin-top:0.9rem;border-radius:0.6rem;cursor:pointer;border:0.1rem solid rgb(var(--color-foreground,18 18 18));background:transparent;color:rgb(var(--color-foreground,18 18 18));transition:opacity 0.2s ease,transform 0.1s ease;}.t8-upsell__btn:first-of-type{margin-top:0;}.t8-upsell__btn:hover{opacity:0.88;}.t8-upsell__btn:active{transform:translateY(0.1rem);}.t8-upsell__btn--primary{background:rgb(var(--color-foreground,18 18 18));color:rgb(var(--color-background,255 255 255));}.t8-upsell__btn-title{font-size:1.4rem;font-weight:600;letter-spacing:0.02rem;}.t8-upsell__btn-sub{font-size:1.15rem;line-height:1.35;opacity:0.8;font-weight:400;}.t8-upsell-wrap--busy{opacity:0.6;pointer-events:none;}.t8-upsell__btn[disabled]{opacity:0.5;cursor:default;}';
    (document.head || document.documentElement).appendChild(st);
  })();

  var MOVEMENT = 40794068615222;
  var SUPER = 40574190157878;
  var PILATES = 43012687396918;
  var BOX = 43480568823862;

  var injecting = false;

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function domUnits(drawer) {
    var total = 0, lines = 0, single = null;
    drawer.querySelectorAll('.cart-item').forEach(function (row) {
      var input = row.querySelector('[data-quantity-variant-id]');
      if (!input) return;
      var vid = Number(input.getAttribute('data-quantity-variant-id'));
      var qty = Number(input.value || input.getAttribute('value') || 0);
      total += qty;
      lines += 1;
      single = { vid: vid, qty: qty };
    });
    return { total: total, lines: lines, single: single };
  }

  function computeState(drawer) {
    var u = domUnits(drawer);
    /* SUPPRESSION, all of it, in one condition.

       The offer only exists for a cart holding exactly one unit on exactly one
       line. That single test is what suppresses every case we care about:

         two or more sets          total is 2 or more, so no offer
         an Upgrade Your Two8 Experience package, all four of them:
           BAND TOGETHER  box x2                       total 2
           PLUS ONE       box + Super Band             total 2, lines 2
           HOW TO MOVE    box + the book               total 2, lines 2
           ALL IN         box + Super Band + the book  total 3, lines 3
         anything else already in the cart alongside the box   lines 2 or more

       The line count is checked as well as the unit count so the rule stays
       true if a package is ever sold as one line at quantity one.

       State is read here, at render time, off the live drawer DOM, and
       freshnessCheck() reconciles that against /cart.js every time the drawer
       opens. Nothing is cached from page load. */
    if (u.total !== 1 || u.lines !== 1 || !u.single || u.single.qty !== 1) return { key: 'none' };
    if (u.single.vid === MOVEMENT || u.single.vid === SUPER) return { key: 'a', variant: u.single.vid };
    if (u.single.vid === PILATES) return { key: 'b' };
    /* v8.2.1 addition: the Two8 Bands system box path. */
    if (u.single.vid === BOX) return { key: 'c' };
    return { key: 'none' };
  }

  function markup(state) {
    if (state.key === 'a') {
      return '' +
        '<p class="t8-upsell__heading">One band gets you moving. The set gets you flowing.</p>' +
        '<button type="button" class="t8-upsell__btn t8-upsell__btn--primary" data-t8-action="swap" data-t8-from="' + state.variant + '">' +
          '<span class="t8-upsell__btn-title">Upgrade to the Two8 Bands box</span>' +
          '<span class="t8-upsell__btn-sub">The complete experience. Free shipping and a free coaching session included.</span>' +
        '</button>' +
        '<button type="button" class="t8-upsell__btn t8-upsell__btn--secondary" data-t8-action="add" data-t8-variant="' + state.variant + '">' +
          '<span class="t8-upsell__btn-title">Add a second band and save 28%</span>' +
          '<span class="t8-upsell__btn-sub">Two bands, more range, and free shipping unlocks.</span>' +
        '</button>';
    }
    if (state.key === 'b') {
      /* v8.2: the "Upgrade to the Two8 Bands system" swap button is suppressed on
         this path. Pilates in a Box is $44 and the system is $50, so a $6 step
         was trading a $50 sale for a $44 one and pulling buyers off the final
         run. To put it back, restore the swap button block that sat here.
         The add-a-second-set button below is promoted to primary. */
      return '' +
        '<p class="t8-upsell__heading">Pilates is better with a partner.</p>' +
        '<button type="button" class="t8-upsell__btn t8-upsell__btn--primary" data-t8-action="add" data-t8-variant="' + PILATES + '">' +
          '<span class="t8-upsell__btn-title">Add a second set and save 28%</span>' +
          '<span class="t8-upsell__btn-sub">One for you, one for them. Both from the final run.</span>' +
        '</button>';
    }
    if (state.key === 'c') {
      /* v8.2.1: Two8 Bands system box. Same shape as the other paths. More of what
         they already chose, framed as a gift. No swap, the box is the top of the line.
         v8.2.2: copy only. This is the one place on the store the second-set offer
         is allowed, so it does not have to shout a percentage to earn the click.
         The buyer has already decided. The question is who trains beside them.
         The automatic add-on discount reveals itself in the cart total. */
      return '' +
        '<p class="t8-upsell__heading">One set for you. One set to give.</p>' +
        '<button type="button" class="t8-upsell__btn t8-upsell__btn--primary" data-t8-action="add" data-t8-variant="' + BOX + '">' +
          '<span class="t8-upsell__btn-title">Add a second set</span>' +
          '<span class="t8-upsell__btn-sub">Training beside someone changes the work. Keep one, hand one over.</span>' +
        '</button>';
    }
    return '';
  }

  function inject() {
    if (injecting) return;
    var drawer = drawerEl();
    if (!drawer) return;
    var ctas = drawer.querySelector('.cart__ctas');
    var state = computeState(drawer);
    var key = state.key === 'a' ? 'a:' + state.variant : state.key;
    var existing = drawer.querySelector('.t8-upsell-wrap');
    if (existing && existing.getAttribute('data-key') === key) return;

    injecting = true;
    if (existing) existing.remove();
    if (state.key !== 'none' && ctas) {
      var wrap = document.createElement('div');
      wrap.className = 't8-upsell-wrap';
      wrap.setAttribute('data-key', key);
      wrap.innerHTML = '<div class="t8-upsell t8-upsell--' + state.key + '">' + markup(state) + '</div>';
      ctas.parentNode.insertBefore(wrap, ctas);
    }
    injecting = false;
  }

  function config() {
    return { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
  }

  function addVariant(variantId) {
    var c = config();
    c.body = JSON.stringify({ items: [{ id: variantId, quantity: 1 }] });
    return fetch('/cart/add.js', c).then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); });
  }

  function removeVariant(variantId) {
    var c = config();
    c.body = JSON.stringify({ id: String(variantId), quantity: 0 });
    return fetch('/cart/change.js', c).then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); });
  }

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var parser = new DOMParser();
        if (data['cart-drawer']) {
          var doc = parser.parseFromString(data['cart-drawer'], 'text/html');
          var newInner = doc.querySelector('.drawer__inner');
          var curInner = document.querySelector('cart-drawer .drawer__inner');
          if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
          var cd = drawerEl();
          if (cd) { cd.classList.remove('is-empty'); cd.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); }
        }
        if (data['cart-icon-bubble']) {
          var bdoc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
          var newBubble = bdoc.querySelector('.shopify-section') || bdoc.body;
          var target = document.getElementById('cart-icon-bubble');
          if (newBubble && target) target.innerHTML = newBubble.innerHTML;
        }
        inject();
      });
  }

  function freshnessCheck() {
    var drawer = drawerEl();
    if (!drawer) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var dom = domUnits(drawer).total;
      if (Number(cart.item_count) !== dom) { refreshDrawer(); } else { inject(); }
    }).catch(function () {});
  }

  function setBusy(wrap, busy) {
    if (!wrap) return;
    wrap.classList.toggle('t8-upsell-wrap--busy', busy);
    wrap.querySelectorAll('button').forEach(function (b) { b.disabled = busy; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-t8-action]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.t8-upsell-wrap');
    var action = btn.getAttribute('data-t8-action');
    var addVar = Number(btn.getAttribute('data-t8-variant') || 0);
    var fromVar = Number(btn.getAttribute('data-t8-from') || 0);
    setBusy(wrap, true);
    var op;
    if (action === 'swap') {
      op = addVariant(BOX).then(function () { return fromVar ? removeVariant(fromVar) : null; });
    } else {
      op = addVariant(addVar);
    }
    op.then(function () { return refreshDrawer(); }).catch(function (err) {
      console.error('[two8-upsell]', err);
      setBusy(wrap, false);
    });
  });

  function watch() {
    var drawer = drawerEl();
    if (!drawer) { return; }
    var inner = drawer.querySelector('.drawer__inner') || drawer;
    var mo = new MutationObserver(function () { if (!injecting) inject(); });
    mo.observe(inner, { childList: true, subtree: true });
    var ao = new MutationObserver(function () {
      if (drawer.classList.contains('active')) freshnessCheck();
    });
    ao.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    inject();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
